import React, { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

import HolidayTipsHeader from './HolidayTipsHeader'
import HolidayTipsBody from './HolidayTipsBody'
import HolidayTipsPayment from './HolidayTipsPayment'
import HolidayTipsPaymentResult from './HolidayTipsPaymentResult'

const HolidayTips = () => {
  const [showPaymentResult, setShowPaymentResult] = useState(false)
  const [member, setMember] = useState(null)
  const navigate = useNavigate()
  const location = useLocation()

  const clearUrl = () => navigate('/optimatips')

  const handleClosePaymentResult = () => {
    clearUrl()
    setShowPaymentResult(false)
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location?.search ?? '')
    if (queryParams.size > 0) {
      const status = queryParams.get('status')
      if (status === 'success') {
        setShowPaymentResult(true)
      } else {
        clearUrl()
      }
    }
  }, [location?.search])

  return (
    <div className="holiday-tips">
      {showPaymentResult ? (
        <div>
          <HolidayTipsPaymentResult type="success" onClose={handleClosePaymentResult} />
        </div>
      ) : (
        <div>
          {member ? (
            <HolidayTipsPayment member={member} setMember={setMember} />
          ) : (
            <React.Fragment>
              <HolidayTipsHeader />
              <HolidayTipsBody setMember={setMember} />
            </React.Fragment>
          )}
        </div>
      )}
    </div>
  )
}

export default HolidayTips
